import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';
import './index.css';
import logo from '../../imagens/Sem fundo.png';

const Home = () => {
  const { setUserInfo } = useUser();
  const [empresa, setEmpresa] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const navigate = useNavigate();
  const url = 'https://api.wensystem.com.br';

  const empresaInputRef = useRef(null);

  useEffect(() => {
    const savedEmpresa = localStorage.getItem('empresa');
    const savedUsername = localStorage.getItem('username');
    const savedPassword = localStorage.getItem('password');

    if (savedEmpresa && savedUsername && savedPassword) {
      setEmpresa(savedEmpresa);
      setUsername(savedUsername);
      setPassword(savedPassword);
      setRemember(true);
    }

    // 👇 coloca o foco automaticamente no campo empresa
    if (empresaInputRef.current) {
      empresaInputRef.current.focus();
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const upperUsername = username.toUpperCase();

      if (!upperUsername || !password) {
        alert('Por favor, preencha todos os campos.');
        return;
      }

      if (remember) {
        localStorage.setItem('empresa', empresa);
        localStorage.setItem('username', upperUsername);
        localStorage.setItem('password', password);
      } else {
        localStorage.removeItem('empresa');
        localStorage.removeItem('username');
        localStorage.removeItem('password');
      }

      const credentials = btoa(`${empresa};${upperUsername}:${password}`);
      const response = await fetch(url + '/login/v1', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'empresa': empresa,
          'Authorization': `Basic ${credentials}`,
        }
      });

      if (response.ok) {
        const data = await response.json();

        if (Array.isArray(data) && data.length > 0 && data[0].login) {
          if (data[0].login === "Login realizado com sucesso!") {
            setUserInfo({
              username: data[0].nome,
              company: data[0].empresa,
              ven_id: data[0].venId,
              dpc_id: data[0].dpcId,
              venLogin: data[0].venLogin,
              venSenha: data[0].venSenha,
              venFlexDisponivel: data[0].venFlexDisponivel,
              controlaEstoque: data[0].controlaEstoque,
              bloqFinanceiro: data[0].bloqFinan,
              limiteCredito: data[0].contLimCredito,
              descontoPedido: data[0].descontoPedido,
              descontoFinanceiro: data[0].descontoFinanceiro,
              taxaEntrega: data[0].taxaEntrega,
              alterarPreco: data[0].alterarPreco,
              tabelaPreco: data[0].tabelaPreco,
              cadastrarCliente: data[0].cadastrarCliente,
              bloqueioCusto: data[0].bloqueioCusto,
              bloqueioHorario: data[0].bloqueioHorario,
              horaInicioLiberado: data[0].horaInicioLiberado,
              horaFinalLiberado: data[0].horaFinalLiberado,
              mensagem: data[0].ativarMensagem,
              editarPedido: data[0].editarpedido,
              limitarPrazoBoleto: data[0].limitarPrazoBoleto,
              controlaFlex: data[0].controlaFlex,
              enviarEmailPedido: data[0].enviarEmialPedido,
              emailEnvioPedido: data[0].emialEnvioPedido,
              obrigatotiodataentrega: data[0].obrigatotioDataEntrega,
              alterarEmbalagem: data[0].alterarEmbalagem,
              clientenegativado: data[0].clienteNegativado,
              agenda: data[0].agenda,
              gerencial: data[0].gerencial,
              complementoPedido: data[0].complementoPedido,
              tabelaIndividual: data[0].tabelaIndividual,
              bloqClienteIncompleto: data[0].bloqClienteInconpleto,
              televendas: data[0].televendas,
              url: url,
              alias: empresa,
            });
            navigate('/rotas');
          } else {
            alert('Login falhou. Por favor, verifique suas credenciais.');
          }
        } else {
          alert('Login ou senha inexistente. Por favor, tente novamente.');
        }
      } else {
        alert('Falha ao fazer login. Por favor, tente novamente.');
      }
    } catch (error) {
      alert('Ocorreu um erro ao fazer login. Por favor, tente novamente.');
    }
  };

  return (
    <div className="login-container">
      <img
        src={logo}
        alt="Logo"
        className="login-logo"
      />
      <h1>WEN-ROTERIZAÇÃO LOGIN</h1>
      <form onSubmit={handleLogin} className="login-form">
        <input
          type="text"
          placeholder="Empresa"
          value={empresa}
          onChange={(e) => {
            const value = e.target.value
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .replace(/\s+/g, "")
              .toUpperCase();
            setEmpresa(value);
          }}
          required
          autoComplete="organization"
        />

        <input
          type="text"
          placeholder="Nome do Usuário"
          value={username}
          onChange={(e) => setUsername(e.target.value.toUpperCase())}
          required
          autoComplete="username"
        />

        <div className="password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value.toUpperCase())}
            required
            autoComplete="current-password"
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="eye-icon"
          >
            {showPassword ? '🙈' : '👁️'}
          </span>
        </div>

        <label className="remember-me">
          <input
            type="checkbox"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          /> Lembrar dados
        </label>
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default Home;